var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import Avatar from "backpack-ui/dist/components/avatar";
import * as cn from "classnames";
import * as React from "react";
import * as styles from "./styles.css";
export var LinkAvatar = function (_a) {
    var imageSrc = _a.imageSrc, className = _a.className, rest = __rest(_a, ["imageSrc", "className"]);
    return (React.createElement("a", __assign({}, rest, { className: cn(styles.linkAvatar, className) }),
        React.createElement(Avatar, { src: imageSrc, size: 40 })));
};



//////////////////
// WEBPACK FOOTER
// ./app/shared/patterns/global/header/link/linkAvatar.tsx
// module id = kYuW
// module chunks = 2